function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { AttrsSchema, Component, jsx } from 'panel';
import customEventsSvg from 'common/assets/images/charts/flows-custom-events.svg';
import collapseRepeatedSvg from 'common/assets/images/charts/flows-collapse-repeated.svg';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { AdvancedQueryOptions } from 'common/report/flows/models/types';
import { SelectEl } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { SwitchEl } from 'common/components/switch';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { IronContextRegistry } from 'common/report/context-registry';
import css from './index.inline.styl';
export type AdvancedSettingsItem = {
  option: AdvancedQueryOptions;
  toggled: boolean;
};
type FlowsAdvancedSettingsAttrs = {
  items: AdvancedSettingsItem[];
};
export type FlowsAdvancedSettingsChangeEvent = CustomEvent<AdvancedSettingsItem>;
export interface FlowsAdvancedSettingsJsxProps {
  attrs: FlowsAdvancedSettingsAttrs;
  on: {
    change: (ev: FlowsAdvancedSettingsChangeEvent) => void;
  };
}
export class FlowsAdvancedSettings extends Component<EmptyObj, FlowsAdvancedSettingsAttrs, unknown, unknown, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<FlowsAdvancedSettingsAttrs> {
    return _objectSpread(_objectSpread({}, super.attrsSchema), {}, {
      items: {
        type: "json",
        tsType: "AdvancedSettingsItem[]"
      }
    });
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      contexts: ["i18n" as const],
      template: () => {
        const itemsMap = new Map(this.attr("items").map(item => [item.option, item]));
        const t = this.getContext("i18n").t;
        return <SelectEl sel='.flows-advanced-settings' attrs={{
          theme: SelectTheme.Secondary,
          icon: {
            leftIcon: "ellipsis"
          },
          'icon-only': true,
          'selected-option': ""
        }}>
            <div sel='.advanced-options-container' attrs={{
            slot: "body"
          }}>
              {itemsMap.has(AdvancedQueryOptions.CollapseRepeated) && this.renderSwitchOption({
              item: itemsMap.get(AdvancedQueryOptions.CollapseRepeated),
              name: t("flows.advanced-options.collapse"),
              tooltipText: t("flows.advanced-options.collapse-tooltip"),
              tooltipImg: collapseRepeatedSvg
            })}
              {itemsMap.has(AdvancedQueryOptions.ShowCustomEvents) && this.renderSwitchOption({
              item: itemsMap.get(AdvancedQueryOptions.ShowCustomEvents),
              name: t("flows.advanced-options.custom-events"),
              tooltipText: t("flows.advanced-options.custom-events-tooltip"),
              tooltipImg: customEventsSvg
            })}
              {itemsMap.has(AdvancedQueryOptions.TimePercentiles) && this.renderSwitchOption({
              item: itemsMap.get(AdvancedQueryOptions.TimePercentiles),
              name: t("flows.advanced-options.time-percentiles")
            })}
              {itemsMap.has(AdvancedQueryOptions.AlwaysBreakdown) && this.renderSwitchOption({
              item: itemsMap.get(AdvancedQueryOptions.AlwaysBreakdown),
              name: t("flows.advanced-options.breakdown")
            })}
            </div>
          </SelectEl>;
      }
    };
  }
  renderSwitchOption(_ref: {
    item: AdvancedSettingsItem;
    name: string;
    tooltipText?: string;
    tooltipImg?: string;
  }) {
    let {
      item,
      name,
      tooltipText,
      tooltipImg
    }: {
      item: AdvancedSettingsItem;
      name: string;
      tooltipText?: string;
      tooltipImg?: string;
    } = _ref;
    return <div sel='.option-container'>
        <SwitchEl attrs={{
        on: item.toggled
      }} on={{
        change: ev => this.handleOptionChange(ev.detail.on, item.option)
      }} />
        {tooltipText && <TooltipEl attrs={{
        placement: Placement.Left,
        offset: 10,
        'max-width': "200px",
        text: tooltipText,
        'image-src': tooltipImg
      }} />}
        <span>{name}</span>
      </div>;
  }
  handleOptionChange(toggled: boolean, option: AdvancedQueryOptions) {
    const event: FlowsAdvancedSettingsChangeEvent = new CustomEvent("change", {
      detail: {
        toggled,
        option
      }
    });
    this.dispatchEvent(event);
  }
}
export const FlowsAdvancedSettingsEl = defineAndMakeJsxFactory<FlowsAdvancedSettingsJsxProps>("flows-advanced-settings", FlowsAdvancedSettings);
export const FlowsAdvancedSettingsReact = panel2react<FlowsAdvancedSettingsJsxProps>("flows-advanced-settings", FlowsAdvancedSettings);